import { handleFirebaseError } from '../../../error-handling';
import { addMemberToOrganization } from '../addMemberToOrganization';

export async function addExaminerToOrganization(
  organizationId: string,
  examinerId: string,
  addedBy: string
): Promise<boolean> {
  try {
    return await addMemberToOrganization(organizationId, examinerId, 'examiner', addedBy);
  } catch (error) {
    handleFirebaseError(error, 'Error adding examiner to organization');
    return false;
  }
} 